
<div *ngIf="userRules">
  <table style="margin: 0px 12px; width: 100%" id="userTable">
    <tr>
      <td style="width: 40%">
        <h4 class="control-row-name">Rule:</h4>
      </td>
      <td style="width: 40%">
        <p-dropdown
            [options]="userRules"
            [(ngModel)]="rule"
            styleClass="form-control"
            placeholder="Select a Rule"
            optionLabel="ruleName"
            (onChange)="resetRuleDetails()"
            [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
          'padding-left': '16px', 'font-size': '13px', 'text-shadow': 'none'}">
        </p-dropdown>
      </td>
      <td style="width: 20%">
        <button type="button" class="btn btn-primary btn-save"
                style="margin-left: 18px;"
                [class.disabled]="loading || selectedRule !== undefined"
                (click)="addRule()">
          Add Rule
        </button>
      </td>
    </tr>
    <tr>
      <td colspan="3"><div class="rule-control-spacer"></div></td>
    </tr>
  </table>

  <current-rule
                [selectedRule]="selectedRule"
                [allRules]="userRules"
                (mapChanged)="updateRule($event)"
                (clearRule)="clearRuleDetails($event)"
                [selectedUserId]="selectedUserId"
  ></current-rule>


</div>
